import { services } from '@broadleaf/admin-components';
import {AuroraContentFields} from "./AuroraContentFields";
const { ComponentRegistrar } = services;

ComponentRegistrar.registerFieldComponent('CONTENT_FIELDS', AuroraContentFields);